import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  return (
    <footer className="bg-neutral-800 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")'
      }}></div>

      <div className="relative px-8 pt-20 pb-12">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-8 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/b77abd256c0fcd5d12b7048a94ca1456.jpeg" 
                  alt="Daro Tattoo Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="text-xl font-bold tracking-wider" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                DARO TATTOO
              </span>
            </div>
            <p className="text-neutral-400 text-sm leading-relaxed mb-2">
              Estudio profesional de tatuajes en Adra
            </p>
            <p className="text-neutral-400 text-sm leading-relaxed mb-2">
              Arte personalizado desde 2015
            </p>
            <p className="text-neutral-400 text-sm leading-relaxed">
              Calidad y confianza garantizadas
            </p>
          </div>

          <div>
            <h4 className="text-neutral-300 text-xs font-bold uppercase tracking-wider mb-5">
              Mantente Informado
            </h4>
            <form onSubmit={handleSubmit} className="relative">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Tu email"
                className="w-full bg-transparent border-b-2 border-neutral-600 text-white placeholder-neutral-500 py-3 pr-10 focus:outline-none focus:border-white transition-colors text-sm"
                required
              />
              <button 
                type="submit"
                className="absolute right-0 top-1/2 -translate-y-1/2 text-neutral-400 hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </form>
            {subscribed && (
              <p className="text-green-400 text-xs mt-2">¡Gracias por suscribirte!</p>
            )}
            <p className="text-neutral-600 text-xs mt-4">
              Al suscribirte aceptas nuestra <a href="#" className="underline hover:text-neutral-400 cursor-pointer">política de privacidad</a>
            </p>
          </div>

          <div>
            <h4 className="text-neutral-300 text-xs font-bold uppercase tracking-wider mb-5">
              Navegación
            </h4>
            <ul className="space-y-4">
              <li>
                <a href="#portfolio" className="text-white text-sm hover:text-neutral-400 transition-colors cursor-pointer">
                  Portfolio
                </a>
              </li>
              <li>
                <a href="#reservar" className="text-white text-sm hover:text-neutral-400 transition-colors cursor-pointer">
                  Reservar Cita
                </a>
              </li>
              <li>
                <a href="#faq" className="text-white text-sm hover:text-neutral-400 transition-colors cursor-pointer">
                  Preguntas Frecuentes
                </a>
              </li>
              <li>
                <Link to="/politica-privacidad" className="text-white text-sm hover:text-neutral-400 transition-colors cursor-pointer">
                  Política de Privacidad
                </Link>
              </li>
              <li>
                <Link to="/politica-privacidad" className="text-white text-sm hover:text-neutral-400 transition-colors cursor-pointer">
                  Aviso Legal
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-white text-sm hover:text-neutral-400 transition-colors cursor-pointer">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-neutral-300 text-xs font-bold uppercase tracking-wider mb-5">
              Síguenos
            </h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href="https://wa.me/34658402605?text=%C2%A1Hola!%20Me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n%20sobre%20Daro%20Tattoo%20%F0%9F%92%AC"
                  target="_blank" 
                  rel="noopener noreferrer nofollow"
                  className="flex items-center gap-3 text-white text-sm hover:text-[#25D366] transition-colors cursor-pointer"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-whatsapp-line text-lg"></i>
                  </div>
                  WhatsApp Directo
                </a>
              </li>
              <li>
                <a 
                  href="https://www.instagram.com/Daro_tattoo_" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white text-sm hover:text-neutral-400 transition-colors cursor-pointer"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-instagram-line text-lg"></i>
                  </div>
                  Instagram @Daro_tattoo_
                </a>
              </li>
              <li>
                <a href="#" className="flex items-center gap-3 text-white text-sm hover:text-neutral-400 transition-colors cursor-pointer">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-facebook-line text-lg"></i>
                  </div>
                  Facebook
                </a>
              </li>
              <li>
                <a 
                  href="https://www.google.com/maps/search/Daro+Tattoo+Adra" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white text-sm hover:text-neutral-400 transition-colors cursor-pointer"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-google-line text-lg"></i>
                  </div>
                  Google Reviews
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-neutral-700 pt-12 relative">
          <div className="text-center mb-8">
            <h2 
              className="text-[60px] sm:text-[80px] lg:text-[120px] font-bold tracking-tighter leading-none opacity-15 select-none"
              style={{ 
                fontFamily: 'Bebas Neue, sans-serif',
                color: '#D4C5B0',
                letterSpacing: '-3px'
              }}
            >
              DARO TATTOO
            </h2>
          </div>
          
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-neutral-600">
            <div className="flex items-center gap-4">
              <span className="px-3 py-1 bg-neutral-700/50 rounded">Estudio Certificado</span>
              <span className="px-3 py-1 bg-neutral-700/50 rounded">Pago Seguro</span>
            </div>
            <div className="flex items-center gap-3">
              <p>© 2025 Daro Tattoo. Todos los derechos reservados</p>
              <span className="text-neutral-700">|</span>
              <Link to="/politica-privacidad" className="hover:text-neutral-400 transition-colors cursor-pointer">Privacidad</Link>
              <span className="text-neutral-700">|</span>
              <Link to="/politica-privacidad" className="hover:text-neutral-400 transition-colors cursor-pointer">Aviso Legal</Link>
            </div>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-neutral-400 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}